import * as React from 'react';
const SvgPrintSupport = (props) => (
  <svg viewBox="0 0 124 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M32 110H2V2h74v16"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M48 18 76 2M122 18H48v108h74V18Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M104 34H66v36h38V34ZM66 86h38M66 98h38M66 110h38"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPrintSupport;
